import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import {
  Button,
  Card,
  Col,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-bootstrap';

import Flex from 'componentes/common/Flex.js';
import { Link } from 'react-router-dom';
import { statusIcons } from 'helpers/GetIcons.js';
import { ApiEndpoint } from 'helpers/ApiEndPoint.js';
import { httpClient } from 'helpers/HttpClient.js';
import { useAuth } from 'context/AuthProvider.js';
import { FormatDate, FormatDateToDb, FormatTime } from 'helpers/FormatData.js';
import classNames from 'classnames';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BtnExportToExcell from 'componentes/generic/ExportToExcel.js';

const URI = ApiEndpoint + 'operations/';
const Event = ({ details, isLast }) => {
  return (
    <Flex>
      <div className="calendartime">
        <span className="calendar-header"></span>
        <span
          className="calendar-time"
          style={{ fontWeight: 'bold', fontSize: '12px' }}
        >
          {FormatTime(details.fecha)}
        </span>
      </div>
      <div className="flex-1 position-relative ps-3">
        <h6 className="fs-9 mb-0">
          <Row>
            <Col>
              <Link
                target=""
                to={'/Quejas/Detalle/' + details.idrecepcionqueja}
              >
                <strong>
                  {details.expediente}/{details.nombreconsumidor}
                </strong>
              </Link>
            </Col>
            <Col className="text-end">
              <span
                className={`badge badge-${
                  statusIcons.find(item => item.status === details.status).type
                } rounded-pill `}
              >
                {details.status}
              </span>
            </Col>
          </Row>
          <Row>
            <Col>
              <p className="mb-0"> {details.tipoproducto}</p>
            </Col>
          </Row>
        </h6>
        <p className="mb-1">
          {details.determinante}/ {details.subcliente}
        </p>
        <p className="text-1000 mb-0">{details.clasificacionqueja}</p>

        <p className="mb-0">Delegacion: {details.delegacion}</p>

        {!isLast && <div className="border-dashed border-bottom my-3"></div>}
      </div>
    </Flex>
  );
};
Event.propTypes = {
  details: PropTypes.object,
  isLast: PropTypes.bool
};

const EventsList = ({ selectedDate }) => {
  const Auth = useAuth();
  var userData = Auth.getSessionData();

  const [events, setEvents] = useState([]);
  const [selectedFilterDate, setSelectedFilterDate] = useState(selectedDate);
  const getDateData = async () => {
    setEvents(null);
    httpClient(
      'POST',
      URI + 'day/',
      {
        from: FormatDateToDb(selectedFilterDate)
      },
      userData.token
    )
      .then(function (response) {
        if (!response.data.error) {
          const normalized = response.data.map(
            // eslint-disable-next-line no-unused-vars
            ({ classname, start, end, ...rest }) => ({
              ...rest
            })
          );
          setEvents(normalized);
        }
      })
      .catch(function (error) {
        console.log(error);
      })
      .finally(() => {});
  };

  const AddOneDay = () => {
    const date = new Date(selectedFilterDate);
    date.setDate(date.getDate() + 1);
    setSelectedFilterDate(date);
  };
  const MinusOneDay = () => {
    const date = new Date(selectedFilterDate);
    date.setDate(date.getDate() - 1);
    setSelectedFilterDate(date);
  };

  useEffect(() => {
    if (selectedFilterDate) getDateData();
  }, [selectedFilterDate]);
  return (
    <Card style={{ minHeight: '800px' }}>
      <Card.Header className={classNames({ 'bg-body-tertiary': 'light' })}>
        <Row className="align-items-center g-2">
          <Col>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={{ position: 'fixed' }} id="nextTooltip">
                  Anterior
                </Tooltip>
              }
            >
              <Button
                variant="link"
                className="icon-item p-0 me-1 ms-md-2"
                onClick={() => {
                  MinusOneDay();
                }}
              >
                <FontAwesomeIcon icon="arrow-left" />
              </Button>
            </OverlayTrigger>
          </Col>
          <Col className="center" style={{ textAlign: 'center' }}>
            <h5 className={classNames('mb-0')}>
              {FormatDate(selectedFilterDate)}
            </h5>
          </Col>
          <Col style={{ textAlign: 'right', display: 'ruby' }}>
            <OverlayTrigger
              placement="bottom"
              overlay={
                <Tooltip style={{ position: 'fixed' }} id="nextTooltip">
                  Siguiente
                </Tooltip>
              }
            >
              <Button
                variant="link"
                className="icon-item p-0 me-1 ms-md-2"
                onClick={() => {
                  AddOneDay();
                }}
              >
                <FontAwesomeIcon icon="arrow-right" />
              </Button>
            </OverlayTrigger>
          </Col>
        </Row>
      </Card.Header>
      <Card.Body className="fs-10 border-bottom">
        {events &&
          events.map((event, index) => (
            <Event
              key={event.id}
              details={event}
              isLast={index === events.length - 1}
            />
          ))}
      </Card.Body>
      <Card.Footer>
        {events && (
          <Row className="align-items-center">
            <Col>
              <h6 className="mb-0">Total de registros: {events.length}</h6>
            </Col>
            <Col className="text-end">
              <BtnExportToExcell
                dataReport={events}
                fileName={'Quejas' + FormatDate(selectedFilterDate)}
              />
            </Col>
          </Row>
        )}
      </Card.Footer>
      {/* <FalconCardFooterLink title="All Events" to={paths.eventList} size="sm" /> */}
    </Card>
  );
};
EventsList.propTypes = {
  selectedDate: PropTypes.object
};

export default EventsList;
